import React from 'react';
import LicenseDetail from '../../components/LicenseDetail';
import Licenses from './Licenses';

const CreateWrapper = (props) => (
  <LicenseDetail {...props} actionType="create" />
);
const EditWrapper = (props) => <LicenseDetail {...props} actionType="edit" />;

const resource = {
  list: Licenses,
  create: CreateWrapper,
  edit: EditWrapper,
};

export default resource;
